import { SvgProps } from 'models/svg';

const MapPinSvg = ({ className }: SvgProps) => {
  return (
    <svg width='8' height='13' viewBox='0 0 8 13' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
      <path
        d='M4.75 7.15625V11.75C4.75 12.1719 4.42188 12.5 4 12.5C3.57812 12.5 3.25 12.1719 3.25 11.75V7.15625C1.75 6.82812 0.625 5.49219 0.625 3.875C0.625 2.02344 2.14844 0.5 4 0.5C5.875 0.5 7.375 2.02344 7.375 3.875C7.375 5.49219 6.25 6.82812 4.75 7.15625ZM4.1875 2.75C4.49219 2.75 4.75 2.49219 4.75 2.1875C4.75 1.88281 4.49219 1.625 4.1875 1.625C2.85156 1.625 1.75 2.72656 1.75 4.0625C1.75 4.36719 2.00781 4.625 2.3125 4.625C2.61719 4.625 2.875 4.36719 2.875 4.0625C2.875 3.33594 3.46094 2.75 4.1875 2.75Z'
        fill='#6C727F'
      />
    </svg>
  );
};

export default MapPinSvg;
